import WebhookNode from './triggers/WebhookNode';
import ScheduleNode from './triggers/ScheduleNode';
import ManualTriggerNode from './triggers/ManualTriggerNode';
import OnChainEventNode from './triggers/OnChainEventNode';
import WalletTwoEventNode from './triggers/WalletTwoEventNode';

import SlackNode from './actions/SlackNode';
import TelegramNode from './actions/TelegramNode';
import SendGridNode from './actions/SendGridNode';
import ApiRequestNode from './integrations/ApiRequestNode';

import LoadWalletNode from './wallet/LoadWalletNode';
import TransferNode from './wallet/TransferNode';
import BalanceNode from './wallet/BalanceNode';
import SignNode from './wallet/SignNode';

import ConditionNode from './logic/ConditionNode';
import DelayNode from './logic/DelayNode';
import ForEachNode from './logic/ForEachNode';

import GetMemberNode from './wallettwo/GetMemberNode';
import GetMembersNode from './wallettwo/GetMembersNode';

// Maps each nodeType to its specific component.
// ReactFlow nodeTypes maps broad type keys → components that then
// delegate to the right specific component via this registry.
export const NODE_COMPONENT_REGISTRY = {
  // Triggers
  trigger_webhook: WebhookNode,
  trigger_schedule: ScheduleNode,
  trigger_manual: ManualTriggerNode,
  trigger_onchain: OnChainEventNode,
  trigger_wallettwo: WalletTwoEventNode,

  // Integrations
  action_slack: SlackNode,
  action_telegram: TelegramNode,
  action_sendgrid: SendGridNode,
  action_api_request: ApiRequestNode,

  // Wallet
  wallet_load: LoadWalletNode,
  wallet_transfer: TransferNode,
  wallet_balance: BalanceNode,
  wallet_sign: SignNode,

  // WalletTwo
  wallettwo_get_member: GetMemberNode,
  wallettwo_get_members: GetMembersNode,

  // Logic
  logic_condition: ConditionNode,
  logic_delay: DelayNode,
  logic_foreach: ForEachNode,
};

// ReactFlow requires a nodeTypes map of { typeName: Component }.
// We use broad type keys (triggerNode, actionNode, etc.) and resolve
// the specific component inside each dispatcher.
function createDispatcher(fallbackType) {
  return function Dispatcher(props) {
    const nodeType = props.data?.nodeType;
    const Specific = NODE_COMPONENT_REGISTRY[nodeType];
    if (Specific) return <Specific {...props} />;
    // Fallback: try the generic category
    const Fallback = NODE_COMPONENT_REGISTRY[fallbackType];
    return Fallback ? <Fallback {...props} /> : null;
  };
}

export const nodeTypes = {
  triggerNode: createDispatcher('trigger_manual'),
  actionNode: createDispatcher('action_slack'),
  walletNode: createDispatcher('wallet_load'),
  wallettwoNode: createDispatcher('wallettwo_get_member'),
  conditionNode: createDispatcher('logic_condition'),
};
